import { http } from '@/utils/http';
import { unwrap } from '@/utils/apiClient';

export interface NotificationItem {
  id: number;
  userId: number;
  type: 'gift' | 'payment' | 'compensation' | 'system' | 'achievement';
  title: string;
  content: string;
  sourceType?: string;
  referenceId?: string;
  referenceTable?: string;
  data?: Record<string, any>;
  isRead: boolean;
  readAt?: string;
  displayLevel: 'HIGH' | 'NORMAL';
  status: 'pending' | 'success' | 'failed';
  createdAt: string;
  updatedAt: string;
}

export interface NotificationListResponse {
  list: NotificationItem[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface UnreadCountResponse {
  count: number;
}

export interface GetNotificationListParams {
  page?: number;
  pageSize?: number;
  type?: string;
  isRead?: boolean;
}

/**
 * 通知 API
 */
export const notificationApi = {
  /**
   * 获取通知列表
   */
  getList(params?: GetNotificationListParams) {
    return unwrap<NotificationListResponse>(() =>
      http.get('/api/v1/me/notifications', { params })
    );
  },

  /**
   * 获取未读通知数量
   */
  getUnreadCount() {
    return unwrap<UnreadCountResponse>(() =>
      http.get('/api/v1/me/notifications/unread-count')
    );
  },

  /**
   * 获取通知详情
   */
  getDetail(id: number) {
    return unwrap<NotificationItem>(() =>
      http.get(`/api/v1/me/notifications/${id}`)
    );
  },

  /**
   * 标记通知为已读
   */
  markAsRead(id: number) {
    return unwrap<void>(() =>
      http.post(`/api/v1/me/notifications/${id}/read`)
    );
  },

  /**
   * 标记所有通知为已读
   */
  markAllAsRead() {
    return unwrap<void>(() =>
      http.post('/api/v1/me/notifications/read-all')
    );
  },

  /**
   * 删除通知
   */
  delete(id: number) {
    return unwrap<void>(() =>
      http.delete(`/api/v1/me/notifications/${id}`)
    );
  },

  /**
   * 清空已读通知
   */
  clearRead() {
    return unwrap<{ message: string; deleted_count: number }>(() =>
      http.delete('/api/v1/me/notifications/read')
    );
  }
};
